import { GlInput, GlInputProps } from '@adl/component-input'
import { FC, useState } from 'react'

import { ShowHidePasswordButton } from './ShowHidePasswordButton'

export const PasswordInput: FC<GlInputProps> = props => {
  const [showPassword, setShowPassword] = useState<boolean>(false)
  return (
    <div className="gl-vspace" data-auto-id="password-input">
      <ShowHidePasswordButton showPassword={showPassword} setShowPassword={setShowPassword} />
      <GlInput {...props} type={showPassword ? 'text' : 'password'} />
    </div>
  )
}
